import { BaseIcon } from '@spinwise/react-component-library/BaseIcon';
import styles from './PromoCarouselBlock.module.scss';
import { IconLibrary } from 'Libraries/icons.library';
import { EBrandIconVariants } from 'Libraries/variants.library';
import { useState } from 'react';

interface IPromoCarouselBlock {
  withNavButtons?: boolean;
  children: JSX.Element | JSX.Element[];
}

const PromoCarouselBlock = ({ withNavButtons = true, children }: IPromoCarouselBlock) => {
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const MAX_PAGE_INDEX = ((children as JSX.Element[])?.length || 1) - 1;
  const MIN_PAGE_INDEX = 0;

  return (
    <>
      <div className={`${styles.promo_carousel}`}>
        <div
          className={`${styles.promo_carousel_inner} d-fl ai-c`}
          style={{ transform: `translate(${currentPageIndex * -100}%)` }}
        >
          {children}
        </div>
        {withNavButtons == true && (
          <div className={`${styles.nav_arrow_container} d-fl ai-c jc-sb`}>
            {currentPageIndex != MIN_PAGE_INDEX && (
              <div
                className={`${styles.arrow_container} ${styles.arrow_rotate} d-fl ai-c jc-c`}
                onClick={() => {
                  if (currentPageIndex - 1 >= MIN_PAGE_INDEX) setCurrentPageIndex(currentPageIndex - 1);
                }}
              >
                <BaseIcon iconName={IconLibrary.ArrowRight} variant={EBrandIconVariants.Black} />
              </div>
            )}
            {currentPageIndex == MIN_PAGE_INDEX && (
              <div
                className={`${styles.arrow_container} ${styles.arrow_rotate} d-fl ai-c jc-c`}
                onClick={() => {
                  if (currentPageIndex - 1 >= MIN_PAGE_INDEX) setCurrentPageIndex(currentPageIndex - 1);
                }}
              >
                <BaseIcon iconName={IconLibrary.ArrowRight} variant={EBrandIconVariants.Black04} />
              </div>
            )}

            {currentPageIndex != MAX_PAGE_INDEX && (
              <div
                className={`${styles.arrow_container} d-fl ai-c jc-c`}
                onClick={() => {
                  if (currentPageIndex + 1 <= MAX_PAGE_INDEX) setCurrentPageIndex(currentPageIndex + 1);
                }}
              >
                <BaseIcon iconName={IconLibrary.ArrowRight} variant={EBrandIconVariants.Black} />
              </div>
            )}
            {currentPageIndex == MAX_PAGE_INDEX && (
              <div
                className={`${styles.arrow_container} d-fl ai-c jc-c`}
                onClick={() => {
                  if (currentPageIndex + 1 <= MAX_PAGE_INDEX) setCurrentPageIndex(currentPageIndex + 1);
                }}
              >
                <BaseIcon iconName={IconLibrary.ArrowRight} variant={EBrandIconVariants.Black04} />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default PromoCarouselBlock;
